import React, { Fragment, useEffect, useState } from 'react'
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { useHistory } from 'react-router-dom';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useForm } from '../forms/useForm';
import { useDebounce } from '../debounce/useDebounce';
import { usePaginationBackend } from '../pagination/usePaginationBackend';
import { ConfigServer } from '../../data/config';
import { cancelPreInvoice } from '../../services/invoice/invoice'
import { Tag } from 'primereact/tag';
import { Badge, Button, ButtonGroup } from 'reactstrap'
import { StatusCancellationInvoice, StatusPreInvoice, StatusStampedInvoice } from '../../constant/billing';
import { pyrsa, insan } from '../../constant/globalConstantsTypeClients';







export const useViewInvoice = () => {

    const history = useHistory();
    const id_branch = localStorage.getItem("branchId");
    let _url_helen = localStorage.getItem('url_helen');
    console.log("🚀 ~ useViewInvoice ~ _url_helen:", _url_helen)

    // console.log("🚀 ~ pyrsa:", pyrsa)

    //#region GLOBAL VARIABLES
    const [loadingTableInvoice, setLoadingTableInvoice] = useState(false);
    const [loading, setLoading] = useState(false);
    const [method, setMethod] = useState("");
    //#endregion

    //#region  SHOW DISPLAY MESSAGE
    const [createSweet] = useSweetAlert();
    //#endregion

    //#region MODALS
    const [modalTitle, setModalTitle] = useState("");

    const [modalCancellation, setModalCancellation] = useState(false);

    const [preInvoice, setPreInvoice] = useState([]);
    const [modalPre, setModalPre] = useState(false);
    const [message, setMessage] = useState(false)



    const toggleModalCancellation = () => {
        setModalCancellation(!modalCancellation);
        setMessage(false)
    }
    //#endregion

    //#region ViewInvoice

    //#region MODELS
    const [informationInvoice, setInformationInvoice] = useState({});

    const [ListInvoices, setListInvoices] = useState([]);
    const [ListTypeCancellations, setListTypeCancellations] = useState([]);
    const [listbranch, setListBranch] = useState([]);


    //#region FILTERS
    const [searchQuery, setSearchQuery] = useState("");
    const debounceValue = useDebounce(searchQuery, 500);
    const [filters, setFilters] = useState(`&id_branch=${id_branch}`);
    //#endregion END FILTERS



    //#region FORM
    const [formInvoice, handleInputChange, reset, handleUpdateValues] = useForm({
        id_invoice: 0,
        code_type_cancellation: "0",
        code_reference_value: "",
        is_general_public: false,
        id_overdue_invoice: 0,
        typeDocument: 0


    });

    const {
        id_invoice, code_type_cancellation, code_reference_value, is_general_public, id_overdue_invoice, typeDocument
    } = formInvoice;

    const [formFilter, handleInputChangeFilters, resetFilters, handleUpdateValuesFilter] = useForm({
        iSerie: "",
        iFolio: "",
        iRfc: "",
        iTypeDocument: "0",
        iTypePayMethod: "0",
        iDateIni: "",
        iDateEnd: "",
        iBranch: id_branch,
        isgeneral_public: false,
        allBranch: 0,
    });

    const {
        iSerie, iFolio, iRfc, iTypeDocument, iTypePayMethod, iDateIni, iDateEnd, iBranch, isgeneral_public, allBranch
    } = formFilter;
    //#endregion

    //#endregion

    //#region METHODS
    //#region HANDLE METHODS
    const handleCancelInvoice = (_id_invoice) => {

        let _findInvoice = ListInvoices.find(x => x.id_invoice === _id_invoice);

        if (_findInvoice !== undefined) {
            setLoading(false);
            setModalTitle("Cancelación");
            toggleModalCancellation();
            setMethod("cancellation");

            if (_findInvoice.invoiceDisable) {
                setMessage(true)


            }

            setInformationInvoice({
                rfcReceptor: _findInvoice.rfcReceptor,
                commercialName: _findInvoice.commercialName,
                uuid: _findInvoice.uuid,
                serieFolio: _findInvoice.serieFolio,
                dateCreated: _findInvoice.dateCreated,
                codeCoin: _findInvoice.codeCoin,
                total: _findInvoice.total,
                typeDocument: _findInvoice.typeDocument,
                isGeneralPublic: _findInvoice.isGeneralPublic,


            });

            handleUpdateValues({
                id_invoice: _id_invoice,
                code_type_cancellation: _findInvoice.isGeneralPublic ? "04" : "0",
                code_reference_value: "",
                is_general_public: _findInvoice.isGeneralPublic,
                id_overdue_invoice: _findInvoice.id_overdue_invoice ?? 0,
                typeDocument: _findInvoice.typeDocument === "P" ? 1 : 0
            });
        }

    }


    const handleTypeCompany = (_typeClient) => {
        let _valid = _typeClient === 1 ? null : null

        handleUpdateValuesFilter({
            ...formFilter,
            allBranch: _valid
        });
    }

    const handleSearch = (e) => {
        let _search = e.target.value;

        setSearchQuery(_search);
    }

    const handleFilters = () => {

        let _valid = allBranch
        //console.log(_valid);
        let _query = "";

        if (iSerie !== "") {
            _query += `&serie=${iSerie}`;
        }

        if (iFolio !== "") {
            _query += `&folio=${iFolio}`;
        }

        if (iRfc !== "") {
            _query += `&rfc=${iRfc}`;
        }

        if (iTypeDocument !== "0") {
            _query += `&typeDocument=${iTypeDocument}`;
        }

        if (iTypePayMethod !== "0") {
            _query += `&typePayMethod=${iTypePayMethod}`;
        }

        if (iDateIni !== "" && iDateEnd !== "") {
            _query += `&dateIni=${iDateIni}&dateEnd=${iDateEnd}`;
        }

        if (allBranch != null) {
            if (iBranch !== "") {
                _query += `&id_branch=${iBranch}`;
            }
        }
        else {
            _query += `&id_branch=${""}`;
            //console.log("pasa aqui mi filtro");
        }

        if (isgeneral_public !== false) {
            _query += `&is_general_public=${isgeneral_public}`;
        }

        setFilters(_query);
    }

    //console.log(filters);

    const handleEditInvoice = (_id_invoice) => {
        history.push(`../invoice/service/${_id_invoice}`);
    }

    //#endregion

    //#region PAGINATION
    const { goNextPage, goPreviousPage, goToPage, searchAsync, totalRecords, actualPage, totalPages, prevPage, nextPage, resultCount, results, dataA, dataLoading } = usePaginationBackend(
        { method: 'GET' },
        'Invoice/GetListInvoices',
        history,
        searchQuery,
        filters
    );
    //#endregion

    //#region POST METHODS    


    const handleClosedMessage = () => {
        setMessage(false)


    }





    const SaveCancellationInvoice = async () => {

        setLoading(true);

        console.log("cancelacion de la factura");


        let _list = [];

        _list.push({
            id_invoice: formInvoice.id_invoice,
            uuid_from: informationInvoice.uuid,
            cancellation_code: formInvoice.code_type_cancellation,
            uuid_to: formInvoice.code_reference_value,
            id_overdue_invoice: formInvoice.id_overdue_invoice,
            typeDocument: formInvoice.typeDocument
        });



        const _response = await _handleRequest("POST", "Invoice/CreateInvoiceCancellation", "Guardar cancelación", _list);

        if (_response !== null) {
            setLoading(false);
            setModalTitle("");
            setMethod("");
            toggleModalCancellation();

            setInformationInvoice({});
            handleUpdateValues({
                id_invoice: 0,
                code_type_cancellation: "0",
                code_reference_value: "",
                is_general_public: false
            });

            createSweet("create", "success", "Exito!", "Se cancelo correctamente");
        }
        else {
            setLoading(false);
        }
    }

    const DownloadInvoice = async (uuid_invoice, is_preinvoice = false) => {

        if (is_preinvoice) {
            let token = localStorage.getItem("token");

            await fetch(ConfigServer.serverUrl + "/api/Invoice/DownloadPreInvoice/" + uuid_invoice, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                })
            })
                .then(response => {
                    if (response.status !== 200) {
                        createSweet("warning", "warning", "No se descargo el archivo el PDF de la prefactura");
                        return;
                    }

                    return response.blob();
                })
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${uuid_invoice}.pdf`);
                    document.body.appendChild(link);
                    link.style.display = 'none';
                    link.click();
                })
        }
        else {
            const response = await _handleRequest("POST", `Invoice/DownloadPdfInvoice/${uuid_invoice}`, "Descarga de factura");

            if (response !== null) {
                let linkPdf = `data:application/pdf;base64,${response.cadena}`;
                let downloadLink = document.createElement("a");
                let fileName = uuid_invoice + ".pdf";
                downloadLink.href = linkPdf;
                downloadLink.download = fileName;
                downloadLink.style.display = 'none';
                downloadLink.click();
            }
        }
    }

    const DownloadXml = async (id_invoice, uuid_invoice) => {
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/Invoice/DownloadXml/" + id_invoice, {
            method: 'POST',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el archivo Xml");
                    return;
                }
                return response.blob();
            })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${uuid_invoice}.xml`);
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            })
    }

    const DownloadSupport = async (id_invoice) => {
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/Invoice/DownloadInvoiceSupport/" + id_invoice, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se descargo el archivo el PDF del soporte");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `soporte_${id_invoice}.pdf`);
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            })
    }
    //#endregion

    //#endregion

    //#region USE EFFECTS

    useEffect(() => {

        let _list = [];

        results.forEach(_invoice => {

            let fechaHora = _invoice.date_2
            let fechaSinMinutos = fechaHora.split(" ")[0];

            let fechaHora1 = _invoice.date_1
            let fechaSinMinutos1 = fechaHora1.split(" ")[0];


            let visibleTable = true;

            _list.push({
                id_tmp: (Date.now() + _invoice.id_invoice),
                id_invoice: _invoice.id_invoice,
                rfcReceptor: _invoice.rfcReceptor,
                commercialName: _invoice.commercialName,
                isGeneralPublic: _invoice.isGeneralPublic,
                isPatient: _invoice.isPatient,
                isCompany: _invoice.isCompany,
                uuid: _invoice.uuid,
                serieFolio: _invoice.serieFolio,
                dateCreated: _invoice.dateCreated,
                codeCoin: _invoice.codeCoin,
                total: _invoice.total,
                typeDocument: _invoice.typeDocument,
                isEnvelope: _invoice.isEnvelope,
                isPayed: _invoice.isPayed,
                isEnvelopeOpen: _invoice.isEnvelopeOpen,
                statuaInvoice: _invoice.statuaInvoice,
                versionCfdi: _invoice.versionCfdi,
                nameCompany: _invoice.nameCompany,
                type_method: _invoice.type_method,
                status_pay: _invoice.status_pay,
                rfc_cliente: _invoice.rfc_cliente,
                email_cliente: _invoice.email_cliente,
                subtotal: _invoice.subtotal,
                total_tax: _invoice.total_tax,
                total_retentions: _invoice.total_retentions,
                total_i: _invoice.total_i,
                id_pay_method: _invoice.id_pay_method,
                date_1: fechaSinMinutos1,
                date_2: fechaSinMinutos,
                name_agreement: _invoice.name_agreement,
                invoiceDisable: _invoice?.invoiceDisable,
                id_overdue_invoice: _invoice?.id_overdue_invoice ?? 0,
                visibleTable: visibleTable
            });
        });
        setListInvoices(_list);

    }, [results]);

    useEffect(() => {
        searchAsync();
    }, [debounceValue]);

    useEffect(() => {
        if (filters !== "") {
            searchAsync();
        }
    }, [filters]);

    useEffect(() => {

        setListTypeCancellations([
            {
                code: "01",
                description: "(01) COMPROBANTE EMITIDO CON ERRORES CON RELACIÓN"
            },
            {
                code: "02",
                description: "(02) COMPROBANTE EMITIDO CON ERRORES SIN RELACIÓN"
            },
            {
                code: "03",
                description: "(03) NO SE LLEVO ACABO LA OPERACIÓN"
            },
            {
                code: "04",
                description: "(04) OPERACIÓN NOMINATIVA RELACIONADA EN LA FACTURA GLOBAL"
            },
        ]);
        getBranch();

    }, []);

    //#endregion

    //#endregion

    //#region BRANCHES
    const getBranch = () => {
        const arrayBranch = JSON.parse(localStorage.getItem('list_branch_storage'));
        setListBranch(arrayBranch);
    }
    //#endregion
    const handleInputChangeFilters2 = (event) => {
        const { name, value } = event.target;

        if (name === 'iBranch' && value === '0') {
            handleUpdateValuesFilter({
                ...formFilter,
                iBranch: null,
                allBranch: null,
            });
        } else if (name === 'iBranch' && value !== '0') {
            handleUpdateValuesFilter({
                ...formFilter,
                iBranch: value,
                allBranch: 0,
            });
        } else {
            handleUpdateValuesFilter({
                ...formFilter,
                [name]: value,
            });
        }
    };



    // * CANCEL PRE-INVOICE

    const tooglePreInvoice = () => {
        setModalPre(!modalPre)
    }

    const handleCancelPreInvoice = (_pre_inovice) => {
        let _find = ListInvoices.find(x => x?.id_invoice === _pre_inovice);

        if (_find !== null) {
            setModalPre(!modalPre)
            setPreInvoice({
                rfcReceptor: _find?.rfcReceptor,
                commercialName: _find?.commercialName,
                serieFolio: _find?.serieFolio,
                dateCreated: _find?.dateCreated,
                codeCoin: _find?.codeCoin,
                total: _find?.total,
                typeDocument: _find?.typeDocument,
                id_invoice: _find?.id_invoice
            })
        }
    }

    const saveCancelInvoice = async (_pre_inovice, _folio) => {
        const cancell = await cancelPreInvoice(_pre_inovice);

        if (cancell !== null) {

            let _find = ListInvoices.find(x => x?.id_invoice === _pre_inovice);

            if (_find) {
                _find.statuaInvoice = "Cancelada";
            }
            setListInvoices([...ListInvoices]);
            createSweet("create", "success", "Exito!", `Se cancelo correctamente la prefactura ${_folio}`);
            tooglePreInvoice()

        }
    }

    //#region excel.

    const [loadingReport, setLoadingReport] = useState(false)


    const downdloadExcel = async () => {
        setLoadingReport(true);

        let _token = localStorage.getItem("token");

        await fetch(`/api/Invoice/DownloadListInvoices?${filters}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + _token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Reporte_De_Facturas.xlsx");
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();

                setLoadingReport(false);
            })
            .catch(error => {
                console.error("Error al descargar el archivo:", error);
                setLoadingReport(false);
            });
    };

    // ? TAGS
    const fechaFolioTag = (rowData) => {
        const serieAndFolio = rowData.serieFolio ?? '';
        const isGeneralPublic = rowData.isGeneralPublic === true;
        const isPreFactura = rowData.uuid === null;

        const tagClass = isGeneralPublic
            ? 'badge-public-general'
            : isPreFactura
                ? 'badge-prefactura'
                : 'badge-primary';

        return (
            <Tag
                className={`mr-2 f-12 pointerCursor ${tagClass}`}
                value={serieAndFolio}
                style={{
                    fontSize: '0.7rem',
                    padding: '2px 6px',
                    maxWidth: '120px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            />
        );
    };



    const receptorInvoice = (rowData) => {
        const rfcReceptor = rowData.rfcReceptor ?? '';
        const commercialName = rowData.commercialName ?? '';
        const name_agreement = rowData.name_agreement ?? '';


        return (
            <div style={{ textAlign: 'center', lineHeight: '1.2' }}>
                <b>{rfcReceptor}</b>
                <br />
                <span>{commercialName}</span>
                <br />
                <span
                    title={name_agreement}
                    style={{ color: "#0d3b59" }}
                    className={_url_helen === pyrsa ? "f-w-600 pointer" : "d-none"}
                >
                    {name_agreement && name_agreement.length > 25
                        ? name_agreement.substring(0, 18) + "..."
                        : name_agreement}
                </span>
            </div>
        );
    };


    const typeDocumentTag = (_invoice) =>
    (
        <td style={{ verticalAlign: "middle" }}>
            <Badge color={_invoice.typeDocument === "I" ? "success" : (_invoice.typeDocument === "P" ? "info" : "danger")} className='rounded-pill f-12'>{_invoice.typeDocument}</Badge>
        </td>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                {
                    rowData.isGeneralPublic === true ?
                        <div>
                            {
                                <label className='txt-secondary'>{rowData.date_1} <br /> {rowData.date_2}</label>
                            }
                        </div>
                        :
                        <div>
                            {rowData.isEnvelope
                                ? <i className="icofont icofont-check-circled f-16 text-success f-w-700" title='Factura Enviada' ></i>
                                : <i className="icofont icofont-close-circled f-16 text-danger f-w-700" title='Factura No enviado' ></i>}

                        </div>
                }
            </div>
        );
    };

    const actionPayed = (rowData) => {
        return (
            <div>
                {rowData.isPayed
                    ? <i className="icofont icofont-check-circled f-16 text-success f-w-700" title='Factura Pagada' ></i>
                    : <i className="icofont icofont-close-circled f-16 text-danger f-w-700" title='Factura Pendiente' ></i>}
            </div>
        );
    }

    const actionIsEnvelopeOpen = (rowData) => {

        if (rowData.isGeneralPublic === true) {
            return (
                <div>
                    {rowData.id_pay_method === 1 ? (
                        <label className="f-w-600 f-12 badge badge-light-secondary">Efectivo</label>
                    ) : rowData.id_pay_method === 2 ? (
                        <label className="f-w-600 f-12 badge badge-light-secondary">T.C</label>
                    ) : rowData.id_pay_method === 4 ? (
                        <label className="f-w-600 f-12 badge badge-light-secondary">T.D</label>
                    ) : rowData.id_pay_method === 8 ? (
                        <label className="f-w-600 f-12 badge badge-light-secondary">T.E</label>
                    ) : (
                        <label className="f-w-600 f-12 badge badge-light-secondary">Otro</label>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    {rowData.isEnvelopeOpen ? (
                        <i className="icofont icofont-search f-16 text-success f-w-700"></i>
                    ) : (
                        <i className="icofont icofont-restaurant-search f-16 text-danger f-w-700"></i>
                    )}
                </div>
            );
        }
    };

    const actionDownloadPdf = (_invoice) =>
    (
        <td style={{ verticalAlign: "middle", cursor: "pointer" }} id={`tooltip-downloadI-${_invoice.id_tmp}`} onClick={() => DownloadInvoice((_invoice.statuaInvoice === StatusPreInvoice ? _invoice.id_invoice : _invoice.uuid), (_invoice.statuaInvoice === StatusPreInvoice ? true : false))}>
            <i className="icofont icofont-download-alt f-16 text-success f-w-700" title='Descargar PDF' ></i>
        </td>
    );

    const actionDownloadXml = (_invoice) => {
        const isPreInvoice = _invoice.statuaInvoice === StatusPreInvoice;

        return isPreInvoice ? (
            <i className="text-info f-w-700">---</i>
        ) : (
            <i
                className="icofont icofont-download-alt f-16 text-info f-w-700"
                style={{ cursor: "pointer", verticalAlign: "middle" }}
                onClick={() => DownloadXml(_invoice.id_invoice, _invoice.uuid)}
                title='Descargar xml'
            />
        );
    };

    const actionDownloadSupport = (_invoice) => {

        if (_invoice.typeDocument === "P") return null;

        return (
            <i
                className="icofont icofont-download-alt f-16 text-info f-w-700"
                style={{ cursor: "pointer", verticalAlign: "middle" }}
                onClick={() => DownloadSupport(_invoice.id_invoice)}
                title='Descargar Soporte'
            />
        );
    };

    const actionStatusInvoice = (_invoice) => {
        let tagClass = '';
        let label = _invoice.statuaInvoice;

        if (label === StatusPreInvoice) {
            tagClass = 'badge-prefactura';
        } else if (label === StatusStampedInvoice) {
            tagClass = 'badge-stamped';
        } else {
            tagClass = 'badge-cancelada';
        }

        return (
            <Tag
                value={label}
                className={`f-12 pointerCursor ${tagClass}`}
                style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                }}
                title={label === StatusPreInvoice ? "Prefactura" : label === StatusStampedInvoice ? "Timbrado" : "Cancelado"}
            />
        );
    };

    const [isGeneral, setIsGeneral] = useState(false)

    const actionInvoiceOptions = (_invoice, _is_general) => {
        console.log(_is_general);

        const buttons = [];



        if (
            _invoice.statuaInvoice !== StatusCancellationInvoice &&
            _invoice.statuaInvoice !== StatusPreInvoice
        ) {
            buttons.push(
                <Button
                    key="cancel"
                    size="xs"
                    color="danger"
                    onClick={() => handleCancelInvoice(_invoice.id_invoice)}
                >
                    <i className="icofont icofont-close-circled"></i>
                </Button>
            );
        }

        if (_invoice.statuaInvoice === StatusPreInvoice) {
            buttons.push(
                <Button
                    key="edit"
                    size="xs"
                    color="warning"
                    style={{ marginRight: "2px" }}
                    onClick={() => handleEditInvoice(_invoice.id_invoice)}
                >
                    <i className="icofont icofont-edit"></i>
                </Button>
            );
        }

        if (_invoice.statuaInvoice === StatusPreInvoice) {
            buttons.push(
                <Button
                    key="delete"
                    size="xs"
                    color="danger"
                    onClick={() => handleCancelPreInvoice(_invoice.id_invoice)}
                >
                    <i className="fa fa-trash-o"></i>
                </Button>
            );
        }

        return <ButtonGroup>{buttons}</ButtonGroup>;

    };

    // ? END CONFIGURATION DATATABLE


    //#endregion excel

    const _handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, _handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    return {

        listbranch,

        //#region RETURN GLOBAL VARIABLES
        loadingTableInvoice, loading, method,
        //#endregion

        //#region MODALS
        modalTitle, modalCancellation, toggleModalCancellation,
        //#endregion

        //#region RETURN VIEW INVOICE
        // RETURN MODELS
        informationInvoice, ListInvoices, ListTypeCancellations,

        id_invoice, code_type_cancellation, code_reference_value, is_general_public,

        handleInputChange,

        //RETURN FILTERS
        iSerie, iFolio, iRfc, iTypeDocument, iTypePayMethod, iDateIni, iDateEnd, iBranch,

        handleInputChangeFilters,

        //RETURN HANDLE METHODS
        handleCancelInvoice, SaveCancellationInvoice, handleSearch,
        handleFilters, DownloadInvoice, DownloadXml, DownloadSupport,
        handleEditInvoice,

        //RETURN PAGINATION
        goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
        prevPage, nextPage, totalRecords, resultCount,
        downdloadExcel, isgeneral_public,
        allBranch, handleTypeCompany,

        // ? CONFIGURATION PRE INVOICE
        preInvoice, tooglePreInvoice, modalPre, handleCancelPreInvoice, saveCancelInvoice,
        fechaFolioTag, receptorInvoice, typeDocumentTag, actionBodyTemplate, actionPayed, actionIsEnvelopeOpen, actionDownloadPdf,
        actionDownloadXml, actionDownloadSupport, actionStatusInvoice, actionInvoiceOptions, dataLoading, handleInputChangeFilters2,
        loadingReport,

        //#endregion 

        message, handleClosedMessage,
        _url_helen, insan, isGeneral

    }
}

